export default __webpack_public_path__ + "bdc7ddb0f2b46c808b16282a4b7ee53d.png";